// 封装高阶组件
// 核心逻辑: 有token 正常跳转  无token 去登录

import { Navigate } from 'react-router-dom'
import { Spin } from 'antd'
import { useSelector } from 'react-redux'

export function AuthRoute ({ children }) {
  const { authStatus, token } = useSelector((state) => state.user)

  if (authStatus === 'initializing') {
    return (
      <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
        <Spin size="large" tip="正在恢复登录状态" />
      </div>
    )
  }

  if (authStatus === 'authenticated' && token) {
    return <>{children}</>
  } else {
    return <Navigate to={'/login'} replace />
  }
}
